/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';

export const SpeakerSlash = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20.52 7.228a6.75 6.75 0 010 9.546M7.5 8.251v7.5M17.87 9.88a3 3 0 010 4.242M4.5 3.75l15 16.5M14.25 14.475V21L7.5 15.75H3a.75.75 0 01-.75-.75V9A.75.75 0 013 8.25h4.5l.64-.498M10.515 5.906l3.735-2.905v7.014"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SpeakerSlash;
